import { notify } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { QuoteStatus } from '@features/invoices/enums/quoteStatus'
import { useUpdateQuoteStatus } from '@features/invoices/hooks/quotes/useUpdateQuoteStatus'
import { getQuoteQueryKey } from '@features/invoices/utils/getQuoteQueryKey'

import { queryClient } from '../../../../../../../config/queryClient'
import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { useQuote } from '../../../contexts/quoteContext'

export const useQuoteStatusActions = () => {
  const { t } = useTranslation()
  const { quoteId } = useQuote()
  const { updateQuoteStatus, isProcessing } = useUpdateQuoteStatus()

  const markQuoteAsSent = useCallback(() => {
    updateQuoteStatus(
      { quoteId, value: QuoteStatus.Sent },
      {
        onError: () => {
          notify({
            id: NotificationKeys.QuoteMarkedAsSent,
            message: t('error_marking_as_sent'),
            variant: 'error',
          })
        },
        onSuccess: () => {
          notify({
            id: NotificationKeys.QuoteMarkedAsSent,
            message: t('quotes.quote_marked_as_sent'),
            variant: 'success',
          })
          queryClient.invalidateQueries(getQuoteQueryKey(quoteId))
        },
      },
    )
  }, [quoteId, t, updateQuoteStatus])

  const markQuoteAsUnsent = useCallback(() => {
    updateQuoteStatus({ quoteId, value: QuoteStatus.Unsent })
  }, [quoteId, updateQuoteStatus])

  return { markQuoteAsSent, markQuoteAsUnsent, isProcessing }
}
